import React, { useEffect } from 'react';
import { Card, Row, Col, Badge, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBuilding, 
  faUsers, 
  faHome, 
  faLayerGroup, 
  faChartLine, 
  faPlus, 
  faUserShield 
} from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import SuperAdminDashboard from '../admin/SuperAdminDashboard';
import ManagerDashboard from './ManagerDashboard';
import TenantDashboard from './TenantDashboard';

const Dashboard = () => {
  const { currentUser, userRole, userCompany } = useAuth();
  const navigate = useNavigate();

  // Show loading while determining role
  if (!userRole) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Render appropriate dashboard based on user role
  if (userRole === 'admin') {
    return <SuperAdminDashboard />;
  } else if (userRole === 'manager') {
    return <ManagerDashboard />;
  } else if (userRole === 'tenant') {
    return <TenantDashboard />;
  }

  // Fallback for unknown roles
  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Unknown user role. Please contact support.</p>
      </div>
    </div>
  );
};

export default Dashboard; 